<template>
  <div class="item preload">
    <div class="image" />
    <div class="wrapper-main-info">
      <div class="title" />
      <div class="meta-info" />
      <div class="meta-info" />
    </div>
    <div class="action" />
  </div>
</template>

<script setup></script>
<style lang="scss" scoped>
.item {
  width: 264px;
  height: 312px;
  border: 1px solid #E1E5F0;
  background-color: #F6F8FD;
  padding: 18px;
  border-radius: 18px;

  &.preload {
    .image {
      background: linear-gradient(
              107deg, #F6F8FD 36.98%, #E1E5F0 49.48%, #F6F8FD 61.46%
      );
      animation: 1.5s shine linear infinite;
      background-size: 200% 100%;
      height: 142px;
      margin-bottom: 16px;
      border-radius: 12px;
    }

    .wrapper-main-info {
      .title {
        background: linear-gradient(
                107deg, #F6F8FD 36.98%, #E1E5F0 49.48%, #F6F8FD 61.46%
        );
        border-radius: 4px;
        width: 80%;
        margin-top: 3px;
        height: 18px;
        background-size: 200% 100%;
        animation: 1.5s shine linear infinite;
        margin-bottom: 8px;
      }

      .meta-info {
        background: linear-gradient(
                107deg, #F6F8FD 36.98%, #E1E5F0 49.48%, #F6F8FD 61.46%
        );
        animation: 1.5s shine linear infinite;
        background-size: 200% 100%;
        border-radius: 4px;
        width: 100%;
        margin-top: 4px;
        margin-bottom: 8px;
        height: 12px;
      }
    }

    .action {
      background: linear-gradient(
              107deg, #F6F8FD 36.98%, #E1E5F0 49.48%, #F6F8FD 61.46%
      );
      animation: 1.5s shine linear infinite;
      background-size: 200% 100%;
      border-radius: 8px;
      width: 100%;
      margin-top: 8px;
      height: 40px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}
</style>
